import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { environment } from 'src/environments/environment';
import { APIROUTES } from 'src/app/shared/constants';
import { HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastController, LoadingController } from '@ionic/angular';
import { Observable, catchError, of, throwError, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokerInterceptorService {

  excludeURLs: any = {
    login: environment.baseUrl + APIROUTES.AUTH.LOGIN,
    guestLogin: environment.baseUrl + APIROUTES.AUTH.REGISTER_DEVICE_ID_FOR_GUEST
  };

  private isRedirectingToAuth: boolean = false;

  constructor(
    private router: Router,
    public localStorage: StorageService,
    public toastController: ToastController,
    public loading: LoadingController
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let usedRequest: HttpRequest<any> = request;
    const tokenAtRequestTime = this.localStorage.isAuthenticated();
    if (!request.url.includes(this.excludeURLs.login) && !request.url.includes(this.excludeURLs.guestLogin) && !request.url.includes('google')) {
      usedRequest = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + tokenAtRequestTime) });
    }
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

    usedRequest = usedRequest.clone({ params: usedRequest.params.append('timezone', timezone) });

    return next.handle(usedRequest).pipe(
      catchError((error) => {
        let handled: boolean = false;
        if (error instanceof HttpErrorResponse) {
          this.loading.dismiss().finally(() => null);
          switch (error.status) {
            case 401:
              handled = true;
              const currentToken = this.localStorage.isAuthenticated();
              if (currentToken && currentToken !== tokenAtRequestTime) {
                break;
              }
              if (this.localStorage.isGuest()) {
                break;
              }
              if (!this.router.url.includes('auth')) {
                if (this.isRedirectingToAuth) {
                  break;
                }
                this.isRedirectingToAuth = true;
                this.localStorage.clear();
                return from(
                  this.router.navigateByUrl('/auth').finally(() => {
                    this.isRedirectingToAuth = false;
                  })
                );
              }
              if ((error.statusText || error.message) && !this.router.url.includes('next-prayer-day')) {
                this.errorToast(error.statusText || error.message)
              }
              break;
          }
        }
        if (handled) {
          return of(error);
        } else {
          return throwError(error?.error ? error.error : error);
        }
      })
    );
  }

  async errorToast(message: any) {
    const toast = await this.toastController.create({
        message: message,
        color: 'danger',
        buttons: ['OK']
      });
    toast.present();
  }
}